<google-chart #columnchart [title]="title" [type]="chartType" [data]="myData" [options]="options"
    [columns]="columnNames" [style]="cStyle" ></google-chart>